<template>
  <div class="relative h-screen">
    <div
      :class="[
        'h-screen flex flex-col relative',
        !featureAvailable && 'featureScreen',
      ]"
      :style="pickupScreenHeaderBackground"
    >
      <div class="py-6 px-8 flex justify-center">
        <img
          class="rounded-md object-contain h-24"
          :src="
            menu.picture_url
              ? menu.picture_url
              : require('../assets/images/Menu.Logo.png')
          "
          alt="Logo"
          height="32px"
        />
      </div>
      <div 
        class="px-12 pt-8 rounded-t-xxl bg-white mx-16 flex-1 flex flex-col h-[90vh] overflow-auto"
        :style="makeStyles(hasKiosk && mainSectionTopRadius , `box-shadow: 0px -6px 42px -9px rgba(0, 0, 0, 0.2)`)"
      >
      <div v-if="isLoadingData">
      <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
        <MenuItemSkeleton/>
        <MenuItemSkeleton/>
        <MenuItemSkeleton/>
        <MenuItemSkeleton/>
      </div>
      </div>

        <div v-else>
        <div
          v-for="(group, index) in orderUiGroups"
          :key="group['value']"
          class="flex flex-col"
        >
          <h2
            :class="[
              'text-3xl uppercase tracking-widest font-bold text-center mb-6',
              group.labelClass,
            ]"
            :style="pickupScreenFirstTitle"
          >
            {{ group["label"] }}
          </h2>

          <div
              v-if="!ordersData[group['value']].length"
              :style="
                pickupScreenFirstBorder +
                `border-width: 2px !important;
                --highlightColor: ${customThemeVariables['pickup-screen-first--border']}`"
              class="flex items-center  highlight rounded-xl mr-6 mb-6 px-4 py-5 h-24 text-xl"
            >
            <h1
              :style="pickupScreenFirstNameColor"
            >
            No Orders
            </h1>
            </div>


          <div v-else class="flex flex-wrap">
            <OrderScreenItem
              class="col-span-1"
              v-for="customerOrder in ordersData[group['value']]"
              v-if="customerOrder.OrderStatus.Label == 'Paid' || customerOrder.OrderStatus.Label == 'Synced' "
              :key="customerOrder.id"
              :data="customerOrder"
              :index="index"
            />
          </div>
          <hr
            v-if="index !== orderUiGroups.length - 1"
            :style="`border-top-color: ${customThemeVariables['pickup-screen-first--border']};`"
            class="border-t-2 my-12"
          />
        </div>
      </div>
      </div>
    </div>
    <div
      v-if="!featureAvailable"
      class="fixed top-0 right-0 bottom-0 left-0 bg-white bg-opacity-50 flex items-center justify-center"
    >
      <div class="bg-white rouned-xl py-8 px-12 shadow rounded-xl">
        <h1 class="text-3xl text-center">QR-Menu App customer display</h1>
        <h2 class="text-2xl text-center">
          {{lang.contact_support[language||'en']}}
        </h2>
      </div>
    </div>
    <div
      v-if="!featureAvailable"
      class="fixed top-0 right-0 bottom-0 left-0 bg-white bg-opacity-50 flex items-center justify-center"
    >
      <div class="bg-white rouned-xl py-8 px-12 shadow rounded-xl">
        <h1 class="text-3xl text-center">QR-Menu App customer display</h1>
        <h2 class="text-2xl text-center">
          {{ lang.contact_support[language||'en'] }}
        </h2>
      </div>
    </div>
    <div
      v-if="!featureAvailable"
      class="fixed top-0 right-0 bottom-0 left-0 bg-white bg-opacity-50 flex items-center justify-center"
    >
      <div class="bg-white rouned-xl py-8 px-12 shadow rounded-xl">
        <h1 class="text-3xl text-center">QR-Menu App customer display</h1>
        <h2 class="text-2xl text-center">
          {{lang.contact_support[language||'en']}}
        </h2>
      </div>
    </div>
    <div
      v-if="!featureAvailable"
      class="fixed top-0 right-0 bottom-0 left-0 bg-white bg-opacity-50 flex items-center justify-center"
    >
      <div class="bg-white rouned-xl py-8 px-12 shadow rounded-xl">
        <h1 class="text-3xl text-center">QR-Menu App customer display</h1>
        <h2 class="text-2xl text-center">
          {{ lang.contact_support[language||'en'] }}
        </h2>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

import lang from "../lang.js";
import axios from 'axios';

import OrderScreenItem from "../components/OrderScreenItem.vue";
import MenuItemSkeleton from "../components/SkeletonLoaders/MenuItemSkeleton.vue";

const initialState = {
  customerOrders: [],
  readyOrders: [],
};

const orderUiGroups = [
  {
    value: "readyOrders",
    label: "Ready to pick up",
    class: "",
    cols: {
      xl: 4,
    },
  },
  {
    value: "customerOrders",
    label: "Preparing...",
    class: "",
    labelClass: "opacity-60",
    cols: {
      xl: 5,
    },
  },
];

export default {
  computed: {
    orderUiGroups() {
      // return orderUiGroups.filter(({ value }) => this.ordersData[value].length > 0)

      return orderUiGroups;
    },
    featureAvailable() {
      const apiKey = this.$route.query.key;
      const isEnabled = !!this.$route.query.username&&!!this.$route.query.password;

      return apiKey && apiKey !== "" && isEnabled;
    },
    ...mapGetters(["menu","language","hasKiosk"]),
    ...mapGetters("Theme", [
      "customThemeVariables",
      "mainSectionTopRadius",
      "pickupScreenHeaderBackground",
      "pickupScreenFirstTitle",
      "pickupScreenThirdTitle",
      "pickupScreenFirstBorder",
      "pickupScreenFirstBackgroundStatus",
      "pickupScreenSecondBackgroundStatus",
      "pickupScreenFirstTextStatus",
      "pickupScreenFirstNameColor",
      "pickupScreenSecondNameColor",
      "pickupScreenFirstOrderNumber",
      "pickupScreenSecondOrderNumber",
      "pickupScreenSecondTitle",
      "pickupScreenSecondBorder",
      "pickupScreenSecondTextStatus",
      "pickupScreenThirdBorder",
      "pickupScreenRightBorder",
      "pickupScreenThirdOrderNumber",
      "pickupScreenMoreOrdersBackground",
    ]),
  },
    data() {
    return {
      lang: lang,
      ordersData: initialState,
      isLoadingData:true,
      customerOrders: [],
      readyOrders: [],
      hiddenCustomerOrders: [],
      intervalTimer: undefined,
      collectionCode: '',
    };
  },
  components: {
    OrderScreenItem,
    MenuItemSkeleton
},
  mounted() {
    this.$store.commit("updateMenuHash", this.$route.params.menuHash);
    this.$store.dispatch("GET_MENU_ITEMS").then(()=>{
      if (this.featureAvailable) {
        this.getOrders();
        }
    })

  },
  methods: {
    request() {
      // Extract the menuHash from URL query parameters
      const menuHashParam = this.$route.query.menuHash || '';
      const menuHashesArray = menuHashParam.split(',').map(hash => hash.trim());

      // Join the array into a comma-separated string
      const menuHashesString = menuHashesArray.join(',');
      return axios.get(
        `${process.env.VUE_APP_API_BASE_PATH}/GetLastPaidOrdersForDay?menu_id=${this.menu.Id}&username=${this.$route.query.username}&password=${this.$route.query.password}&perDay=${this.$route.query.perDay||0}&useLiteServerVersion=${this.$route.query.useLiteServerVersion||0}&menuHash=${menuHashesString}`,
    {
      headers: {
        Authorization: this.$route.query.key,
      },
    }
  )
  },
    async getOrders() {
      /**
       * @TODO Show notification if no key is configured
       */
      try {
        const { data } = await this.request();

        const filtered = data.reduce((acc, currentOrder) => {
          const label = currentOrder["OrderStatus"].Label;
          const paidAndSynced = label === "Paid" && label === "Synced";
          const isPrepared = currentOrder["Order"].isPrepared;
          const isPickedUp = currentOrder["Order"].isPickedUp;
          this.collectionCode = currentOrder["Order"].CollectionCode;
          /* No need to execute code further if ... */
          if (
            paidAndSynced || // ... an order is paid and synced
            isPickedUp // ... or is picked up
          )
            {
              this.isLoadingData=false;
              return acc;
              }

          /* Decide in which group the order should be located based on the prepare status */
          const setGroup = isPrepared ? "readyOrders" : "customerOrders";

          /**
           * Add current order in the loop, by spreading the original array and adding the object to the new array
           * The name of the new object is calculated above
           */
          this.isLoadingData=false;
          return {
            ...acc,

            [setGroup]: [...acc[setGroup], currentOrder],
          };
        }, initialState);

        this.ordersData = filtered;
        // 5 sec
      let timeoutSeconds=8*1000;

      if(this.$route.query.useLiteServerVersion==1){
        // 2 minutes
        timeoutSeconds=2*60*1000;
      }
      this.isLoadingData=false;
        /**
         * Re-call the method once response received
       */
        setTimeout(this.getOrders, timeoutSeconds);
      } catch (e) {
        // 5 sec
      let timeoutSeconds=8*1000;

      if(this.$route.query.useLiteServerVersion==1){

        // 2 minutes
        timeoutSeconds=2*60*1000;
      }

        console.error(e);
        /** 
         * Re-call the method once response received
        */
       this.isLoadingData=false;
        setTimeout(this.getOrders, timeoutSeconds);
      }
    },
  },

};
</script>

<style scoped>
.orderingHeight {
  height: 70vh;
}

.hiddenCustomerOrderPosition {
  position: absolute;
  bottom: 2rem;
  left: 2rem;
}

.negativeMargin {
  margin-left: -10px;
  z-index: 10;
}

.readyOrdersWidth {
  width: 49%;
}

.featureScreen {
  filter: blur(5px);
}
</style>
